let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kSVGa")).then(() => parcelRequire('5BDEU'));